import {Component} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {AuthService} from "../../../_services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {catchError, filter, first, of} from "rxjs";
import {User} from "../../../_models/user";
import {UsersService} from "../../../_services/users.service";
import {emailValidatorByPattern, minLengthValidator, requiredValidator} from "../../../_util/validators";
import {GlobalStore} from "../../../global.store";
import {TargetCompanyService} from "../../../_services/target-company.service";
import {CompaniesService} from "../../../_services/companies.service";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['../auth.scss'],
    standalone: false
})
export class LoginComponent{
  readonly defaultTitle = 'Welcome to Color Job';
  title = this.defaultTitle;
  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [emailValidatorByPattern(), requiredValidator()]),
    password: new FormControl('', [minLengthValidator('PASSWORD'), requiredValidator()]),
    remember_me: new FormControl()
  })
  isShowPassword: boolean = false;
  returnUrl: string;
  submitted: boolean = false;
  error: boolean = false;
  showLoader = false;

  constructor(private authService: AuthService,
              private router: Router,
              private route: ActivatedRoute,
              private userService: UsersService,
              readonly globalStore: GlobalStore,
              private targetCompanyService: TargetCompanyService,
              private companiesService: CompaniesService) {
    this.route.queryParams.subscribe((params) => {
      this.returnUrl = params['returnUrl']?.toLowerCase();
      const targetCompanyId = this.targetCompanyService.getTargetCompanyId(params['companyId'], this.returnUrl);
      this.targetCompanyService.setTargetCompanyId(targetCompanyId);
    });
    this.loadCompanyTitle();
    this.authService.makeLogoutRequest().subscribe();
  }

  onSubmit() {
    if (this.loginForm.invalid) return;

    this.showLoader = true;

    const remember_me = this.loginForm.get("remember_me")?.value === true ? 'on' : 'off';
    const companyId = this.targetCompanyService.getTargetCompanyId(null, this.returnUrl);
    const loginData = {...this.loginForm.value, remember_me, companyId}
    this.authService.login(loginData).pipe(first()).subscribe((data : User) => {
      if (data.company?.id) this.targetCompanyService.setTargetCompanyId(data.company.id);
      else this.targetCompanyService.clearTargetCompanyId();

      this.globalStore.currentUser$.pipe(filter(user => !!user), first()).subscribe(() => {
        this.globalStore.resetState();
        console.log(1)

        if (!this.returnUrl) {
          this.returnUrl = this.userService.getUserHomePageUrl(data);
          console.log(2)
        }
        else this.returnUrl = this.returnUrl.replace('system/', '').replace('/view', '/builder');

        this.returnUrl = this.returnUrl.replace('noteid', 'noteId');
        console.log(3)
        console.log(this.returnUrl)
        this.router.navigateByUrl(this.returnUrl);
      })
    },
    () => {
      this.submitted = true;
      this.error = true;
      this.showLoader = false;
    });
  }

  private loadCompanyTitle(): void {
    const subdomain = this.getCurrentSubdomain();
    if (!subdomain || subdomain.toLowerCase() === 'app') {
      this.title = this.defaultTitle;
      return;
    }

    this.companiesService.getCompanyBySubdomain(subdomain).pipe(
      first(),
      catchError(() => of(null))
    ).subscribe((company) => {
      if (!company?.name) {
        this.title = this.defaultTitle;
        return;
      }

      this.title = `Welcome to ${company.name}`;
      this.targetCompanyService.setTargetCompanyId(company.id);
    });
  }

  private getCurrentSubdomain(): string | null {
    const hostname = window.location.hostname;
    const mainDomain = 'colorjob.com';

    if (!hostname.endsWith(`.${mainDomain}`)) return null;

    const subdomain = hostname.substring(0, hostname.length - mainDomain.length - 1);
    return subdomain && !subdomain.includes('.') ? subdomain : null;
  }
}
